"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import { useEmoji } from "@/contexts/EmojiContext";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropReaction } from "@/hooks/drops/useDropReaction";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
const WaveDropActionsAddReaction: React.FC<{
  readonly drop: ExtendedDrop;
  readonly isMobile?: boolean | undefined;
  readonly onAddReaction?: (() => void) | undefined;
  readonly dialogZIndexClassName?: string | undefined;
}> = t0 => {
  const $ = _c(56);
  const {
    drop,
    isMobile: t1,
    onAddReaction,
    dialogZIndexClassName
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onAddReaction) {
    t2 = {
      source: "picker",
      onSuccess: onAddReaction
    };
    $[0] = onAddReaction;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    react,
    canReact
  } = useDropReaction(drop, t2);
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef(null);
  const pickerContainerRef = useRef(null);
  const {
    emojiMap,
    categories,
    categoryIcons
  } = useEmoji();
  let t3;
  if ($[2] !== react) {
    t3 = emoji => {
      const emojiText = `:${emoji.id ?? ""}:`;
      setShowPicker(false);
      react(emojiText);
    };
    $[2] = react;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleEmojiSelect = t3;
  let t4;
  let t5;
  if ($[4] !== showPicker) {
    t4 = () => {
      const handleClickOutside = event => {
        const target = event.target as Node;
        if (showPicker && pickerContainerRef.current && !pickerContainerRef.current.contains(target) && buttonRef.current && !buttonRef.current.contains(target)) {
          setShowPicker(false);
        }
      };
      const handleEscape = event_0 => {
        if (event_0.key === "Escape" && showPicker) {
          setShowPicker(false);
        }
      };
      if (showPicker) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    };
    t5 = [showPicker];
    $[4] = showPicker;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== canReact || $[8] !== showPicker) {
    t6 = () => {
      if (!canReact) {
        return;
      }
      setShowPicker(!showPicker);
    };
    $[7] = canReact;
    $[8] = showPicker;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const onReact = t6;
  const t7 = `tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${canReact ? "active:tw-bg-iron-800" : "tw-cursor-default tw-opacity-50"} tw-transition-colors tw-duration-200`;
  const t8 = !canReact;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <svg className="tw-size-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g></svg>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = drop.context_profile_context?.reaction ? "Update Reaction" : "Add Reaction";
  let t11;
  if ($[11] !== t10) {
    t11 = <span className="tw-text-base tw-font-semibold tw-text-iron-300">{t10}</span>;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== onReact || $[14] !== t11 || $[15] !== t7 || $[16] !== t8) {
    t12 = <button className={t7} onClick={onReact} disabled={t8}>{t9}{t11}</button>;
    $[13] = onReact;
    $[14] = t11;
    $[15] = t7;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const mobileContent = t12;
  const t13 = `picker-button tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-[#FFCC22] ${canReact ? "tw-cursor-pointer" : "tw-cursor-default tw-opacity-50"}`;
  const t14 = !canReact;
  let t15;
  if ($[18] !== canReact || $[19] !== drop.id) {
    t15 = canReact ? {
      "data-tooltip-id": `add-reaction-${drop.id}`
    } : {};
    $[18] = canReact;
    $[19] = drop.id;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = `tw-size-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out ${!canReact && "tw-opacity-50"}`;
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g>;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t16) {
    t18 = <svg className={t16} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">{t17}</svg>;
    $[22] = t16;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== onReact || $[25] !== t13 || $[26] !== t14 || $[27] !== t15 || $[28] !== t18) {
    t19 = <button ref={buttonRef} className={t13} onClick={onReact} disabled={t14} aria-label="Add reaction to drop" {...t15}>{t18}</button>;
    $[24] = onReact;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== canReact || $[31] !== drop.context_profile_context?.reaction || $[32] !== drop.id) {
    t20 = canReact && <Tooltip id={`add-reaction-${drop.id}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{drop.context_profile_context?.reaction ? "Update Reaction" : "Add Reaction"}</span></Tooltip>;
    $[30] = canReact;
    $[31] = drop.context_profile_context?.reaction;
    $[32] = drop.id;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t19 || $[35] !== t20) {
    t21 = <>{t19}{t20}</>;
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  const desktopContent = t21;
  const t22 = isMobile ? mobileContent : desktopContent;
  let t23;
  if ($[37] !== categories || $[38] !== categoryIcons || $[39] !== emojiMap || $[40] !== handleEmojiSelect || $[41] !== isMobile || $[42] !== showPicker) {
    t23 = !isMobile && showPicker && createPortal(<div className="tw-fixed tw-inset-0 tw-z-1000 tw-flex tw-items-center tw-justify-center tw-bg-black/50"><div ref={pickerContainerRef} className="tw-rounded-lg tw-bg-iron-800 tw-p-px tw-shadow-lg"><Picker theme="dark" data={data} onEmojiSelect={handleEmojiSelect} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></div>, document.body);
    $[37] = categories;
    $[38] = categoryIcons;
    $[39] = emojiMap;
    $[40] = handleEmojiSelect;
    $[41] = isMobile;
    $[42] = showPicker;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== categories || $[45] !== categoryIcons || $[46] !== dialogZIndexClassName || $[47] !== emojiMap || $[48] !== handleEmojiSelect || $[49] !== isMobile || $[50] !== showPicker) {
    t24 = isMobile && <MobileWrapperDialog isOpen={showPicker} onClose={() => setShowPicker(false)} zIndexClassName={dialogZIndexClassName}><div className="tw-flex tw-size-full tw-items-center tw-justify-center" onTouchMove={_temp}><Picker theme="dark" data={data} onEmojiSelect={handleEmojiSelect} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></MobileWrapperDialog>;
    $[44] = categories;
    $[45] = categoryIcons;
    $[46] = dialogZIndexClassName;
    $[47] = emojiMap;
    $[48] = handleEmojiSelect;
    $[49] = isMobile;
    $[50] = showPicker;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t22 || $[53] !== t23 || $[54] !== t24) {
    t25 = <>{t22}{t23}{t24}</>;
    $[52] = t22;
    $[53] = t23;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  return t25;
};
export default WaveDropActionsAddReaction;
function _temp(e) {
  return e.stopPropagation();
}